import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2020')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('photography') || media.includes('sculpture') || media.includes('video');
  })
  .slice(0, 4);

export default function YoungJoonKwak() {
  const slides = [
    { src: '/uploads/2020/05/RVD8642.jpg', alt: 'Young Joon Kwak work 1' },
    { src: '/uploads/2020/05/RVD8644.jpg', alt: 'Young Joon Kwak work 2' },
    { src: '/uploads/2016/11/2021_11_05_YJK3143-rs-1.jpg', alt: 'Young Joon Kwak work 3' },
    { src: '/uploads/2016/11/2021_11_05_YJK3154-rs-1.jpg', alt: 'Young Joon Kwak work 4' },
    { src: '/uploads/2016/11/2021_11_05_YJK3137-rs-3.jpg', alt: 'Young Joon Kwak work 5' },
    { src: '/uploads/2016/11/2021_11_05_YJK3216-rs.jpg', alt: 'Young Joon Kwak work 6' },
    { src: '/uploads/2016/11/2021_11_05_YJK3179-rs-1.jpg', alt: 'Young Joon Kwak work 7' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Young Joon Kwak</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Young Joon Kwak slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2020</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>This year the KAFA committee, comprised of Rita Gonzalez, Helen Molesworth and Jan Tumlir, confronted a very impressive pool of applicants. Each member of the jury selected a top five, and then after a great deal of mutual deliberation, agreed to nominate Young Joon Kwak for the grant. This artist’s strong community praxis, which revolves around members of the trans, gender non-conforming and POC communities, plays out in multiple forms and expressions, from material experimentation in sculpture and installation, photography and video, to the creation of performative collectives like the Mutant Salon. What impressed us most about Kwak’s work is its mixture of political urgency and unfettered form, which seems destined for a bright future.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Rita Gonzalez, Curator and Head of LACMA Contemporary Art Department</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Helen Molesworth, Writer and Curator</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Jan Tumlir, Writer, Teacher and Curator</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Young Joon Kwak received their MFA from the University of Southern California in 2014, MA in Humanities from the University of Chicago in 2010, and BFA from the School of the Art Institute of Chicago in 2007. A multi-disciplinary artist, Kwak is the founder of Mutant Salon, a roving beauty salon/platform for experimental performance collaborations with their community of queer, trans, femme, POC artists and performers. Kwak has presented solo and collaborative exhibitions and performances internationally at institutions including Cerritos College Art Gallery (2020), Wattis Institute (2019), Walter Phillips Gallery, Banff Centre (2018), the Art Museum of the National University of Colombia, Bogotá (2018), The Broad (2016), Hammer Museum (2016), and REDCAT (2014). Selected group exhibitions have been held at Serendipity Arts Festival, Goa, India (2018), Institute of Contemporary Art, Los Angeles (2018), and Le Pavillon Vendôme Centre d’Art Contemporain, Clichy, France (2015). Kwak is the recipient of the Rema Hort Mann Foundation’s Emerging Artist Grant (2018), and Art Matters Grant (2016). Kwak is the 2020-2021 Artist-in-Residence in Critical Race Studies at Michigan State University. Kwak has taught at University of California, San Diego, California Institute of the Arts, and served as a Mentor in the School of the Art Institute of Chicago’s Low-Residency MFA Program.</p>

            <a href='https://www.youngjoon.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
